export default {
  data() {
    return {
      error: {},
      loading: true,
    };
  },
  async mounted() {
    await this.fetchCandidate();
  },
  methods: {
    async fetchCandidate() {
      await this.withApiErrorHandling(async () => {
        await this.$store.dispatch('candidate/loginByHashId', { hashId: this.hashId });
        await this.$store.dispatch('candidate/fetchData');
      }, 'error', 'loading');
    },
  },
};
